import React from 'react';
import cn from 'classnames';
import Title from 'components/UI/Title';
import * as commonStyles from '../TabList.module.scss';
import * as styles from './DesktopTabs.module.scss';

function DesktopTabs({ tabs, selectedTab, setSelectedTabHandler }) {
  return (
    <div className={styles.tabs} role="tablist">
      {tabs.map((item, index) => {
        const { title } = item;
        const isCurrentTab = title === selectedTab.title;

        return (
          <button
            key={index}
            id={`page-interlinking-tab-${index}`}
            onClick={() => setSelectedTabHandler(item)}
            className={cn(styles.tabButton, commonStyles.tab, isCurrentTab && styles.active)}
            role="tab"
            aria-selected={isCurrentTab}
            aria-controls={`page-interlinking-panel-${index}`}
            tabIndex={isCurrentTab ? 0 : -1}
            disabled={isCurrentTab}
          >
            <Title tag="h3" className={styles.tabTitle}>
              {title}
            </Title>
          </button>
        );
      })}
    </div>
  );
}

export default DesktopTabs;
